import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';

@Component({
    selector: 'inquiry-detail-info',
    templateUrl: './inquiry-detail-info.component.html',
    styleUrls: ['./inquiry-detail-info.component.scss'],
    providers: [MessageService]
})
export class InquiryDetailInfoComponent implements OnInit {
    @Output() changedVisibleInquiryEmit = new EventEmitter<boolean>();

    @Input()
    set _selectedInquiry(value: any) {
        this.selectedInquiry = value;
    }

    selectedInquiry: any = undefined;
    showSidebar: boolean = true;

    public menuItems: MenuItem[] = [
        {
            label: 'Inquiry',
            id: '1'
        }
    ];

    constructor() { }

    ngOnInit(): void { }

    cancel() {
        this.showDetailInfoDialog(false);
    }

    showDetailInfoDialog(increased: any) {
        this.changedVisibleInquiryEmit.emit(increased);
    }

}
